import { render, staticRenderFns } from "./Receivingdetails.vue?vue&type=template&id=5c374dda&scoped=true&"
import script from "./Receivingdetails.vue?vue&type=script&lang=js&"
export * from "./Receivingdetails.vue?vue&type=script&lang=js&"
import style0 from "./Receivingdetails.vue?vue&type=style&index=0&id=5c374dda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c374dda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c374dda')) {
      api.createRecord('5c374dda', component.options)
    } else {
      api.reload('5c374dda', component.options)
    }
    module.hot.accept("./Receivingdetails.vue?vue&type=template&id=5c374dda&scoped=true&", function () {
      api.rerender('5c374dda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delivery/Receivingdetails.vue"
export default component.exports